import React from "react";

const SearchIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clipPath="url(#clip0_1291_13262)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.4304 7.9651C13.4304 10.9835 10.9835 13.4304 7.96508 13.4304C4.94669 13.4304 2.49979 10.9835 2.49979 7.9651C2.49979 4.9467 4.94669 2.4998 7.96508 2.4998C10.9835 2.4998 13.4304 4.9467 13.4304 7.9651ZM12.6441 14.4117C11.3304 15.3668 9.71354 15.9302 7.96508 15.9302C3.56609 15.9302 0 12.3641 0 7.9651C0 3.5661 3.56609 0 7.96508 0C12.3641 0 15.9302 3.5661 15.9302 7.9651C15.9302 9.71354 15.3668 11.3304 14.4117 12.6441L19.2929 17.5253C19.6834 17.9158 19.6834 18.549 19.2929 18.9395L18.9395 19.2929C18.549 19.6834 17.9158 19.6834 17.5253 19.2929L12.6441 14.4117Z"
                    fill="#2275EE"
                />
            </g>
            <defs>
                <clipPath id="clip0_1291_13262">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default SearchIcon;
